import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/google-login.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black/25" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-center justify-center p-4 text-center" }
const _hoisted_4 = {
  key: 0,
  class: "mt-2 py-6 flex flex-col justify-center items-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Google logo",
  class: "h-6 w-6"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Sign in with Google", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Sign in with Phone", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-brand-text opacity-50 pt-8 text-center" }, " By signing in, you agree to terms of service and privacy policy. ", -1)
const _hoisted_10 = {
  key: 1,
  class: "mt-2 py-6 flex flex-col justify-center items-center"
}

import { ref } from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { DevicePhoneMobileIcon } from '@heroicons/vue/24/solid'
import { signInWithRedirect, GoogleAuthProvider, signInWithPopup} from "firebase/auth";
import { useFirebaseAuth } from 'vuefire'
import PhoneLoginComponent from "@/components/PhoneLoginComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginComponent',
  props: {
    onClose: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const open = ref(true)

const closeDialog = () => {
  open.value = false
  props.onClose?.()
}


const auth = useFirebaseAuth();
const error = ref<string | null>(null);

const singInWithGoogle = async () => {
  signInWithPopup(auth, new GoogleAuthProvider())
      .then(() => {
        // localStorage.clear();
        setTimeout(() => {
          window.location.reload();
        })
      })
      .catch((reason) => {
    console.error('Failed signinRedirect', reason)
    error.value = reason
    alert('Failed to sign in with Google ' + reason)
  })
}

const isPhoneSignIn = ref(false)

const singInWithPhone = () => {
  isPhoneSignIn.value = true
}

const onClosePhoneSignIn = () => {
  isPhoneSignIn.value = false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: open.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-10",
        onClose: closeDialog
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "duration-300 ease-out",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "duration-200 ease-in",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "w-full max-w-md transform overflow-hidden rounded-2xl bg-brand-card p-6 text-left align-middle shadow-xl transition-all" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg font-medium leading-6 text-center text-brand-text"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Sign in to your account ")
                        ]),
                        _: 1
                      }),
                      (!isPhoneSignIn.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("button", {
                              onClick: singInWithGoogle,
                              class: "bg-brand text-brand-text font-bold space-x-2 px-4 py-2 rounded-md flex flex-row"
                            }, _hoisted_7),
                            _createElementVNode("button", {
                              onClick: singInWithPhone,
                              class: "bg-brand text-brand-text mt-6 font-bold space-x-2 px-4 py-2 rounded-md flex flex-row"
                            }, [
                              _createVNode(_unref(DevicePhoneMobileIcon), { class: "h-6 w-6" }),
                              _hoisted_8
                            ]),
                            _hoisted_9
                          ]))
                        : _createCommentVNode("", true),
                      (isPhoneSignIn.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(PhoneLoginComponent, { "on-close": onClosePhoneSignIn })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})